export default __webpack_public_path__ + "static/media/icon-at-bar.7a613079.svg";